module.exports = __webpack_public_path__ + "img/tab3.858fbcb0.png";